<template>
  <base-page :title="$t('l.user_manage')" icon="md-people">
    <Row class="full">
      <!-- 左侧单位结构树 -->
      <Col span="5" class="full-y">
        <Row class="full-y">
          <depart-tree-new ref="depart_tree" @on-select="onDepartSelect"></depart-tree-new>
        </Row>
      </Col>
      <!-- 右侧 -->
      <Col span="19" class="full-y">
        <!-- 中间用户列（带头像及姓名） -->
        <Row style="height: 30%">
          <Card id="user-list">
            <p slot="title">
              {{ $t('l.user_list') }}
            </p>
            <!-- 用户编辑、添加 -->
            <Row type="flex" justify="end" slot="extra">
              <Page :page-size="table.page.size"
                    style="margin: 0;margin-bottom: 5px;margin-right: 20%;"
                    :total="table.page.total"
                    :current="table.page.current"
                    @on-change="loadUserData($event)">
              </Page>
              <!-- 用户搜索 -->
              <Input class="margin-right-10" style="width: 20%" v-model="table.page.keyword"
                     search
                     suffix="ios-search"
                     :placeholder="$t('l.remark67')"
                     @on-search="searchUserBlur"/>
              <res-view v-if="currentUserDirectInCompany" key-name="fun_use_add">
                <img @click.prevent="preAdd(true)" class="btn-img"
                     src="/images/device/jiahao.png" alt="">
              </res-view>
            </Row>

            <!-- user-list 组件 -->
            <template v-if="table.data.length">
              <div>
                <user-list :list="table.data" :loading="table.loading" @on-edit="preEdit"
                           @on-delete="preDelete"></user-list>
              </div>
            </template>
            <template v-else>
              <Row type="flex" justify="center">{{ $t('l.no_datas') }}</Row>
            </template>
          </Card>
        </Row>
        <!-- 设备列表 -->
        <Row style="height: 70%">
          <div ref="visibleDevicRow" class="full">
            <Card id="device-list">
              <p slot="title">
                <span>{{ $t('l.visible_device') }}</span>
              </p>
              <Row slot="extra" type="flex" justify="end">
                <!-- 搜索 -->
                <Page :page-size="deviceList.table.page.size"
                      :total="deviceList.table.page.total"
                      :current="deviceList.table.page.current"
                      show-elevator
                      style="margin: 0;margin-right: 10px;"
                      @on-change="loadDeviceData($event,modal.currentDepart)"/>
                <Input class="margin-right-10 " style="width: 20%"
                       v-model="deviceList.table.page.keyword"
                       search
                       suffix="ios-search"
                       :placeholder="$t('l.remark67')"
                       @on-search="searchDeviceBlur"/>
                <!-- 多选用户 -->
                <Select :placeholder="$t('l.selectuserofdevice')"
                        class="margin-right-10"
                        style="width: 20%"
                        @on-change="selectUsers"
                        v-model="modal.currentUsers"
                        multiple
                        clearable>
                  <Option v-for="(user) in table.data" :value="user.id"
                          :key="user.id">{{ user.realname }}
                  </Option>
                </Select>
                <res-view key-name="btn_assigned_lift">
                  <Button type="primary" @click.prevent="assignedTo">
                    {{ $t('l.band_company') }}
                  </Button>
                </res-view>
                <res-view v-if="modal.currentDepart && modal.currentDepart.pid" key-name="btn_unbind">
                  <Button type="error" class="margin-left-10" @click.prevent="removeTo">
                    {{ $t('l.remove_device') }}
                  </Button>
                </res-view>
                <res-view key-name="fun_device_add">
                  <img @click.prevent="onAddDevice" class="btn-img margin-left-10"
                       src="../../../public/images/device/jiahao.png" alt="">
                </res-view>
              </Row>
              <visible-device :offsetHeight="offsetHeight" ref="visibleDevice" solt="content"
                              :loading="deviceList.table.loading"
                              :currentCompany="modal.currentDepart"
                              @refresh="loadDeviceData(deviceList.table.page.current,modal.currentDepart)"
                              :list="deviceList.table.data"></visible-device>
            </Card>
          </div>
        </Row>
      </Col>
    </Row>
    <!-- 弹框模板 -->
    <template>
      <!-- 添加用户 -->
      <lg-modal :width="1224" :title="modal.title" :styles="{top:'20px'}" :show="modal.show"
                :loading="modal.loading" @on-submit="onSubmit"
                @on-cancel="modal.loading=false;modal.show = false;">
        <Form ref="modal_user" :model="modal.user" :rules="formRules" :label-width="130"
              style="max-height: 700px;overflow-y: auto">
          <Row>
            <Col span="14">
              <FormItem :label="$t('l.username')" prop="username">
                <Input :disabled="!!modal.user.id" v-model="modal.user.username"
                       :placeholder="$t('l.username_account')"></Input>
              </FormItem>
              <FormItem style="margin: 20px 0" :label="$t('l.name')" prop="realname">
                <Input v-model="modal.user.realname" :placeholder="$t('l.real_name')"></Input>
              </FormItem>
              <!-- 添加的时候出现或者当前编辑操作者是管理员或者是当前公司的主账号 -->
              <p style="color: red;padding-left: 130px;">{{ $t("l.warn_note") }}{{ $t('l.remark241') }}</p>
              <FormItem v-if="showpwd" :label="$t('l.password')" prop="password">
                <Input :type="passwordType" v-model="modal.user.password"
                       :placeholder="$t('l.password')">
                                        <span @click="changeShowPwd" slot="suffix">
                        <template v-if="showPwdContent">
                              <Icon type="ios-eye"/>
                        </template>
                        <template v-else>
                              <Icon type="ios-eye-off"/>
                        </template>
                    </span>
                </Input>
              </FormItem>
              <FormItem style="margin: 10px 0" v-if="showpwd" :label="$t('l.confirm_password')" prop="confirmPassword">
                <Input :type="passwordType" v-model="modal.user.confirmPassword"
                       :placeholder="$t('l.confirm_password')">
                                        <span @click="changeShowPwd" slot="suffix">
                        <template v-if="showPwdContent">
                              <Icon type="ios-eye"/>
                        </template>
                        <template v-else>
                              <Icon type="ios-eye-off"/>
                        </template>
                      </span>
                </Input>
              </FormItem>
              <p style="color: red;font-size: 12px;margin-left: 130px;margin-bottom: 5px">{{ $t('l.explain25') }}</p>
              <FormItem :label="$t('l.mobile')">
                <!-- 电话号存在不让修改 -->
                <Input v-model="modal.user.mobile" :placeholder="$t('l.mobile')"></Input>
              </FormItem>
              <FormItem style="margin: 20px 0" :label="$t('l.job_num')">
                <Input v-model="modal.user.job_num" :placeholder="$t('l.job_num')"></Input>
              </FormItem>
              <FormItem :label="$t('l.position')" prop="job">
                <Input v-model="modal.user.job" :placeholder="$t('l.position')"></Input>
              </FormItem>
              <FormItem style="margin: 20px 0" :label="$t('l.e_mail')" prop="email">
                <Input v-model="modal.user.email" type="email" :placeholder="$t('l.e_mail')"></Input>
              </FormItem>

              <!--                          2024年12月17日  王欢  电梯专家专有属性-->
              <FormItem style="margin: 20px 0" :label="$t('l.holding_version')" :label-width="160">
                <Input v-model="modal.user.currentVersion" type="text" disabled></Input>
              </FormItem>
              <FormItem style="margin: 20px 0" :label="$t('l.mobile_model')" :label-width="160">
                <Input v-model="modal.user.deviceModel" type="text" disabled></Input>
              </FormItem>
              <FormItem style="margin: 20px 0" :label="$t('l.mobile_sys')" :label-width="160">
                <Input v-model="modal.user.osVersion" type="text" disabled></Input>
              </FormItem>


              <!--<FormItem :label="$t('l.birthday')" prop="birthday">-->
              <!--<DatePicker v-model="modal.user.birthday" type="date" :placeholder="$t('l.birthday')"></DatePicker>-->
              <!--</FormItem>-->
              <!-- 是否开启 -->
              <!-- 权限绑定注释 -->
              <FormItem v-if="$store.state.user.isROOT "
                        :label="$t('l.bl6_active')">
                <Row>
                  <i-switch style="vertical-align: middle" size="small" v-model="modal.user.integratedActiveEnabled"
                            @on-change="(e)=>{modal.user.integratedActiveEnabled=e?1:0;}" :true-value="1"
                            :false-value="0"></i-switch>
                </Row>
              </FormItem>
              <FormItem v-if="$store.state.user.isROOT"
                        :label="$t('l.show_lift_endtime')">
                <Row>
                  <i-switch v-model="modal.user.show_lift_endtime" style="vertical-align: middle" size="small"
                            @on-change="(e)=>{modal.user.show_lift_endtime=e?1:0;}" :true-value="1"
                            :false-value="0"></i-switch>
                </Row>
              </FormItem>
              <p v-if="$store.state.user.isROOT" class="explain">
                {{ $t('l.warn_note') }}：{{ $t('l.explain6') }}</p>
            </Col>
            <Col span="10">
              <FormItem :label="$t('l.department')" prop="j_depart_ids">
                <depart-checker :depart-tree="modal.departTree"
                                @on-select="modal.user.j_depart_ids = $event"/>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </lg-modal>
      <!-- 批量分配设备 -->
      <lg-modal :title="$t('l.remark219')"
                @on-visible-change="(e)=>{modalBind.show = e}"
                :show="modalBind.show"
                :loading="modalBind.loading"
                :styles="{top:'40px'}"
                @on-submit="onSubmitBind"
                @on-cancel="modalBind.show = false;">
        <!--<Tabs size="small">-->
        <!-- 按公司分配电梯 -->
        <!--<TabPane :label="$t('l.band_company')">-->
        <!--<Row>请选择需要绑定的公司</Row>-->
        <Row style="max-height: 550px;overflow-y: auto;">
          <depart-tree-new title="l.band_company" :show="modalBind.showAddButton"
                           @on-select="onSelectBindDepart"></depart-tree-new>
        </Row>
        <!--</TabPane>-->
        <!-- 按用户分配电梯 -->
        <!--<TabPane :label="$t('l.band_user')">-->
        <!--<Card class="full">-->
        <!--<p slot="title">-->
        <!--{{$t("l.band_user")}}-->
        <!--</p>-->
        <!--&lt;!&ndash; 多选用户，可以搜索 &ndash;&gt;-->
        <!--</Card>-->
        <!--</TabPane>-->
        <!--</Tabs>-->
      </lg-modal>
      <!-- 新增电梯 -->
      <lg-modal :width="1200" :title="$t('l.add_device')" :show="modal.showAddDevice" :loading="modal.addLoading"
                @on-submit="onAddSubmit('modal')"
                @on-cancel="modal.addLoading=false;modal.showAddDevice = false;">
        <Form label-position="left" :rules="getRules" ref="modal" :model="modal"
              style="max-height: 700px; overflow-y: auto;overflow-x: hidden;">
          <!-- 设备类型 -->
          <FormItem v-if="!modal.device.id" :label-width="140" :label="$t('l.device_type')">
            <RadioGroup type="button" v-model="modal.device.type"
                        @on-change="changeRadio">
              <Radio v-for="t in search.type.values" :label="t.id" :key="t.id" v-if="t.isAuth&&t.show">
                {{ t.name }}
              </Radio>
            </RadioGroup>
          </FormItem>
          <!-- 名称 -->
          <FormItem :label-width="140" prop="device.name"
                    :label="modal.device.type == 0 ? $t('l.elevator_name'):$t('l.project_name')">
            <Input v-model="modal.device.name" :placeholder="$t('l.elevator_name')"/>
          </FormItem>
          <!-- 2G版的 IMSI-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.IMSI')">
            <Input v-model="modal.device_2g.IMSI"/>
          </FormItem>
          <FormItem :label-width="140"
                    :label="modal.device.type == 4?$t('l.BS'):$t('l.terminal_id')">
            <Input v-model="modal.device.terminal_id" :placeholder="$t('l.terminal_id')"/>
          </FormItem>
          <!-- 2G版的 得添加设备号 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140"
                    :rules="{required: true, message: $t('l.remark33'), trigger: 'blur'}"
                    prop="device_2g.DEVICE_NUM" :label="$t('l.device_num')">
            <Input v-model="modal.device_2g.DEVICE_NUM"/>
          </FormItem>
          <!-- 2G版的层站门 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140"
                    :rules="{required: true, message: $t('l.remark33'), trigger: 'blur'}"
                    prop="device_2g.FLOOR" :label="$t('l.floor_station_door')">
            <Input v-model="modal.device_2g.FLOOR"/>-<Input v-model="modal.device_2g.STATION"/>-<Input
              v-model="modal.device_2g.DOOR"/>
          </FormItem>
          <!-- 2g版的整梯出厂日期 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.leave_factory_date')">
            <DatePicker type="date" v-model="modal.device_2g.MANUFACTUREDATE"></DatePicker>
          </FormItem>
          <!-- 2g版的投用日期 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.throw_in_date')">
            <DatePicker type="date" v-model="modal.device_2g.USEDATE"></DatePicker>
          </FormItem>
          <!-- 2g版的下此年检日期 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.next_year_date')">
            <DatePicker type="date" v-model="modal.device_2g.XCNJRQ"></DatePicker>
          </FormItem>
          <!-- 是否交付 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.Delivery')">
            <RadioGroup v-model="modal.device_2g.Delivery">
              <Radio :label="1">
                <span>是</span>
              </Radio>
              <Radio :label="0">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <!-- 2G版的 合同号-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.CONTRACT')">
            <Input v-model="modal.device_2g.CONTRACT"/>
          </FormItem>
          <!-- 2G版的 安装单位-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.INSTALLATION')">
            <Input v-model="modal.device_2g.INSTALLATION"/>
          </FormItem>
          <!-- 2G版的 安装责任人-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.INSTALLATIONMAN')">
            <Input v-model="modal.device_2g.INSTALLATIONMAN"/>
          </FormItem>
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.INSTALLATIONMANMOBILE')">
            <Input v-model="modal.device_2g.INSTALLATIONMANMOBILE"/>
          </FormItem>
          <!-- 2G版的 使用单位 -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.CONSUMER')">
            <Select v-model="modal.device_2g.CONSUMER"></Select>
          </FormItem>
          <!-- 2G版的 使用场合 USEOCCASION-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.USEOCCASION')">
            <Input v-model="modal.device_2g.USEOCCASION"/>
          </FormItem>
          <!-- 2G版的 产权单位 OWNER-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.OWNER')">
            <Select v-model="modal.device_2g.OWNER"></Select>
          </FormItem>
          <!-- 2G版的 物业单位 PROPERTY -->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.PROPERTY')">
            <Select v-model="modal.device_2g.PROPERTY"></Select>
          </FormItem>
          <!--物业人员 WYRY-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.WYRY')">
            <Input v-model="modal.device_2g.WYRY"/>
          </FormItem>
          <!--物业人员电话 WYDH-->
          <FormItem v-if="modal.device.type == 4" :label-width="140" :label="$t('l.WYDH')">
            <Input v-model="modal.device_2g.WYDH"/>
          </FormItem>
          <!--小区-->
          <FormItem v-if="modal.device.type != 4" :label-width="140" :label="$t('l.community')">
            <Row :gutter="5">
              <Col span="20">
                <Select :placeholder="$t('l.remark71')"
                        v-model="modal.device.community_id"
                        filterable
                        remote
                        ref="setQuery"
                        :remote-method="remoteSearchCommunity"
                        :loading="modal.searchLoading.community_id"
                        @on-change="onCommunitySelect">
                  <Option v-for="(comm) in search.community_id.values" :value="comm.id"
                          :key="comm.id">{{ comm.name }}
                  </Option>
                </Select>
              </Col>
              <Col span="2">
                <Button :title="$t('l.create_community')" @click="preJumpAddCommunity">+</Button>
              </Col>
            </Row>
          </FormItem>
          <!-- 如果是虚拟电梯 可以选择绑定真实电梯 -->
          <FormItem :label-width="140" v-if="modal.device.type==3" :label="$t('l.select_bound_lift')">
            <Select :placeholder="$t('l.select_bound_lift')"
                    filterable
                    remote
                    :remote-method="remoteSearchRealDevices"
                    @on-change="onRealDeviceSelect"
                    :loading="modal.searchLoading.real_devices"
                    v-model="modal.current_selected_terminal">
              <Option v-for="(item,index) in realDevices" :key="index"
                      :value="item.name+'【'+item.terminal_id+'】'">{{ item.name + "【" + item.terminal_id + "】" }}
              </Option>
            </Select>
          </FormItem>
          <FormItem :label-width="140" v-if="modal.device.type==3" :label="$t('l.virtual_lift_id')">
            <Input :disabled="true" v-model="modal.device.vm_device_id"
                   :placeholder="$t('l.virtual_lift_id')"/>
          </FormItem>
          <!--楼宇单元 -->
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.build_unit')">
            <Cascader v-model="modal.choosedLocationIds"
                      :data="modal.locationTree"
                      change-on-select
                      @on-change="onLocationSelect"
                      :placeholder="$t('l.remark74')">
            </Cascader>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.detail_address')">
            <Input type="textarea" v-model="modal.device.address" :placeholder="$t('l.remark75')"></Input>
          </FormItem>
          <FormItem v-if="modal.device.type == 0" class="extra-form-item" prop="totalFloor" :label-width="100"
                    :label="$t('l.total_floor') + ' ' + (modal.device.j_floors.negative + modal.device.j_floors.positive)">
            <input type="hidden" :value="modal.totalFloor" :disabled="modal.device.type==3"/>
            <span class="text-font-size margin-right-5">{{ $t('l.positive_floor') }}</span>
            <InputNumber type="number" v-model="modal.device.j_floors.positive"
                         :disabled="modal.device.type==3" :min="0"
                         :max="(modal.device.device_param.is_through_door?32:64) - modal.device.j_floors.negative"
                         @on-change="onTotalFloorChange($event, 1)"/>
            <span class="text-font-size margin-right-5 margin-left-10">{{ $t('l.negative_floor') }}</span>
            <InputNumber :disabled="modal.device.type==3" type="number"
                         v-model="modal.device.j_floors.negative" :min="0"
                         :max="(modal.device.device_param.is_through_door?32:64) - modal.device.j_floors.positive"
                         @on-change="onTotalFloorChange($event, -1)"/>
            <Poptip transfer
                    :title="$t('l.floor_editor') + (modal.device.device_param.is_through_door?'(' + $t('l.through_door') + ')':'')"
                    placement="bottom" ref="floor_editor">
              <Button class="margin-left-10" @click="modal.showFloorEditor=true;" icon="md-options">
                {{ $t('l.floor_editor') }}
              </Button>
              <Poptip word-wrap :width="300" :content="$t('l.explain10')" transfer>
                <img class="cursor-pointor margin-left-10"
                     src="../../../public/images/question-mark.svg" alt="">
              </Poptip>
              <floor-editor :floors="modal.device.j_floors"
                            :positive="modal.device.j_floors.positive"
                            :negative="modal.device.j_floors.negative"
                            :is-through-door="modal.device.device_param.is_through_door"
                            slot="content"
                            @on-close="$refs.floor_editor.handleClose()"></floor-editor>
            </Poptip>
            <span style="margin: 0 10px">
                            <span class="text-font-size margin-right-5"
                                  style="display: inline-flex;align-items: center">{{ $t('l.through_door') }}</span>
                                    <i-switch @on-change="switch_change_through"
                                              v-model="modal.device.device_param.is_through_door" :false-value="0"
                                              :true-value="1" ref="switch_change_through"
                                              size="large">
                                        <span slot="open">{{ $t('l.open') }}</span>
                                        <span slot="close">{{ $t('l.close') }}</span>
                                    </i-switch>
                                </span>
          </FormItem>
          <!-- 推送方式 -->
          <template v-if="modal.device.type == 0 && showpush">
            <FormItem :label-width="140"
                      :label="$t('l.select_push_city')">
              <RadioGroup @on-change="chooseRadio" v-model="modal.device.regulatory_field.way">
                <!--  推送  参数说明 、 获取推送列表请求参数-->
                <Radio v-for="(elem) in modal.push_way" :label="elem.label" :key="elem.label">
                  <span>{{ elem.name }}</span>
                </Radio>
              </RadioGroup>
            </FormItem>
          </template>
          <div class="filed-list" v-if="showPushFiled">
            <Divider>{{ $t("l.push_filed_setting") }}</Divider>
          </div>
          <Row v-if="showPushFiled">
            <p style="font-weight: bold">{{ $t("l.describe") }}:</p>
            <pre style="color: #A9B0B4">{{ modal.current_describe ? modal.current_describe : '未设置' }}</pre>
          </Row>
          <div v-for="(lt,i) in modal.filed_list" :key="i">
            <FormItem :label-width="200" :label="lt.explain">
              <Input :placeholder="$t('l.remark73')+lt.explain"
                     v-model="modal.device.regulatory_field[lt.filed]"/>
            </FormItem>
          </div>
          <div v-if="showPushFiled">
            <Divider></Divider>
          </div>
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.face')">
            <Input v-model="modal.device.face_id" :placeholder="$t('l.face_terminal_id')"/>
          </FormItem>
          <!--<FormItem :label-width="125" v-if="modal.device.type!=3" :label="$t('l.get_coordinates')">-->
          <!--<span class="text-font-size margin-right-5">{{$t('l.longitude')}}</span>-->
          <!--<InputNumber style="width: 100px" :disabled="true" v-model="modal.device.longitude"-->
          <!--type="number"/>-->
          <!--<span class="text-font-size margin-left-10 margin-right-5">{{$t('l.latitude')}}</span>-->
          <!--<InputNumber style="width: 100px" :disabled="true" v-model="modal.device.latitude"-->
          <!--type="number"/>-->
          <!--<Button size="small" class="margin-left-10" @click="locationModal.show = true">-->
          <!--{{$t('l.select_location')}}-->
          <!--</Button>-->
          <!--</FormItem>-->
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.brand')">
            <Input v-model="modal.device.brand" :placeholder="$t('l.brand')"/>
          </FormItem>
          <p v-if="modal.device.type == 0" class="explain margin-left-0">
            {{ $t('l.warn_note') }}：{{ $t('l.explain11') }}</p>
          <FormItem v-if="$store.state.user.isROOT" :label-width="140" :label="$t('l.manufacturer')">
            <Select :placeholder="$t('l.select_manufacturer2')"
                    v-model="modal.device.factory_cid"
                    filterable
                    remote
                    :remote-method="remoteSearchFactory"
                    :loading="modal.searchLoading.factory"
                    @on-change="remoteSearchFactoryBranch('', 'replace')">
              <Option v-for="(factory) in search.factory_cid.values" :value="factory.id"
                      :key="factory.id">{{ factory.name }}
              </Option>
            </Select>
          </FormItem>
          <p v-if="modal.device.type == 0 && $store.state.user.isROOT" class="explain margin-left-0">
            {{ $t('l.warn_note') }}：{{ $t('l.explain12') }}</p>
          <FormItem :label-width="140" :label="$t('l.manufacturer_branch')"
                    v-if="modal.device.factory_cid>0 && modal.device.type == 0">
            <Select :placeholder="$t('l.remark82')"
                    v-model="modal.device.factory_branch"
                    filterable
                    remote
                    :remote-method="remoteSearchFactoryBranch"
                    :loading="modal.searchLoading.factoryBranch">
              <Option v-for="(factory) in search.factory_branch.values" :value="factory.id"
                      :key="factory.id">{{ factory.name }}
              </Option>
            </Select>
          </FormItem>
          <p v-if="modal.device.factory_cid>0 && modal.device.type == 0" class="explain margin-left-0">
            {{ $t('l.warn_note') }}：{{ $t('l.explain13') }}</p>
          <FormItem :label-width="140" :label="$t('l.mt_company')">
            <Select :placeholder="$t('l.remark83')"
                    v-model="modal.device.mt_cid"
                    filterable
                    remote
                    :remote-method="remoteSearchMT"
                    :loading="modal.searchLoading.mt">
              <Option v-for="(depart) in search.mt_cid.values" :ref="'option'+depart.id"
                      :value="depart.id" :key="depart.id">{{ depart.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem :label-width="137" :label="$t('l.mt_person')">
            <Select :placeholder="$t('l.remark84')"
                    v-model="modal.mt_worker_mbile"
                    multiple
                    filterable
                    :loading="modal.searchLoading.mt_worker">
              <Option v-for="(member) in search.j_mt_woker.values" :value="member.mobile"
                      :key="member.mobile">{{ member.name }}({{ member.mobile }})
              </Option>
            </Select>
            <Button class="margin-left-10" :title="$t('l.add_maintenance')" @click="addMtWorkers">+</Button>
          </FormItem>
          <FormItem :label-width="137" :label="$t('l.principal')">
            <Select :placeholder="$t('l.remark85')"
                    v-model="modal.fzrs_mobile"
                    multiple
                    filterable
                    :loading="modal.searchLoading.fzrLoading">
              <Option v-for="(member) in search.j_fzrs.values" :value="member.mobile"
                      :key="member.mobile">{{ member.name }}({{ member.mobile }})
              </Option>
            </Select>
            <Button class="margin-left-10" :title="$t('l.add_principal')" @click="addFzrs">+</Button>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.lift_id')">
            <Input v-model="modal.device.code" :placeholder="$t('l.lift_id')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.lift_mode')">
            <Input v-model="modal.device.model" :placeholder="$t('l.lift_mode')"/>
          </FormItem>
          <!--电梯类型-->
          <FormItem :label-width="140" :label="$t('l.lift_type')">
            <Select :placeholder="$t('l.remark78')" v-model="modal.device.device_param.type">
              <Option v-for="item in getDeviceTypeList"
                      :value="item.id"
                      :key="item.id">{{ item.lable }}
              </Option>
            </Select>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.rated_speed')">
            <Input v-model="modal.device.device_param.rated_speed" :placeholder="$t('l.rated_speed')"/>
          </FormItem>
          <FormItem :label-width="140" :label="$t('l.rated_load')">
            <Input v-model="modal.device.device_param.rated_load" :placeholder="$t('l.rated_load')"/>
          </FormItem>
          <FormItem v-if="modal.device.type == 0" :label-width="140" :label="$t('l.ad_company')">
            <Select :placeholder="$t('l.remark86')"
                    v-model="modal.device.ad_cid"
                    filterable
                    remote
                    :remote-method="remoteSearchAD"
                    :loading="modal.searchLoading.ad">
              <Option v-for="(depart) in search.ad_cid.values" :value="depart.id" :key="depart.id">
                {{ depart.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- 管理员分配谁能给电梯设置过期时间 -->
          <template v-if="$store.state.user.user.show_lift_endtime||$store.state.user.isROOT">
            <FormItem v-if="modal.device.type == 0" :label-width="140"
                      :label="$t('l.lift_monitor_end_time')">
              <DatePicker type="date" v-model="modal.device.end_time"
                          :placeholder="$t('l.remark200')"></DatePicker>
            </FormItem>
          </template>
          <FormItem v-if="modal.device.type == 0" :label-width="137"
                    :label="$t('l.alarm_mobile')">
            <div style="display: flex;align-content: center;width: 100%">
              <Select :placeholder="$t('l.remark87')" style="width: 80%"
                      v-model="modal.alarm_charger_mobile"
                      multiple
                      @on-change="addElevatorSelectAlarmUser"
                      filterable
                      clearable
                      @on-clear="modal.alarm_charger_mobile = []; modal.device.j_alarm_charger = null;"
                      :loading="modal.searchLoading.alarm_charger">
                <Option v-for="(member) in search.j_alarm_charger.values" :value="member.mobile"
                        :label="member.name"
                        :key="member.mobile">
                            <span>
                                {{ member.name }}({{ member.mobile }})
                              </span>
                </Option>
              </Select>
              <Button style="height: 26px" class="margin-left-10" :title="$t('l.add_alarm_mobile')"
                      @click="addAlarmCharger">+
              </Button>
              <span class="margin-left-5 alarm-desc" @click="alarmDesc">{{ $t("l.alarm_description") }}</span>
            </div>
          </FormItem>
        </Form>
      </lg-modal>
    </template>
  </base-page>
</template>

<script>
import BasePage from "../my-components/base-page";
import DepartTreeNew from "./components/depart-tree-new";
import util from '@/libs/util';
import userList from "./components/user-list";
import LgModal from "../my-components/lg-modal";
import visibleDevice from "./components/visible-device";
import DepartChecker from "./components/depart-checker";
import ResView from '../my-components/res-view';
import FloorEditor from "../device/component/floor-editor";
import {validatePass} from "@/common/validate";

let roleTypes = {
  ROOT: 1,
  AMDIN: 2,
  PROXY: 3,
  ELEV_FACTORY: 4,
  MT_COMPANY: 5,
  WY_COMPANY: 6,
  GOV: 7,
  AD: 8,
  CONSUMER: 10
}

export default {
  name: "page-new-user",
  components: {DepartTreeNew, FloorEditor, ResView, BasePage, userList, visibleDevice, LgModal, DepartChecker},
  data() {
    return {
      //手机号验证
      validateMobile: (rule, value, callback) => {
        if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error(this.$t('l.remark11')));
        }
            // else if (!this.modal.user.id) {
            //   util.ajax.get('user/checkuser?mobile=' + value).then(res => {
            //     if (!res.code) {
            //       callback();
            //     } else {
            //       callback(new Error(this.$t('l.remark12')));
            //     }
            //   })
            // } else if (this.modal.user.id) { // 编辑
            //   util.ajax.get(`user/checkuserupdate?mobile=${value}&id=${this.modal.user.id}`).then(res => {
            //     if (!res.code) {
            //       callback();
            //     } else {
            //       callback(new Error(this.$t('l.remark12')));
            //     }
            //   })
        // }
        else callback();
      },
      // 检验用户名
      // validateUsername: (rule, value, callback) => {
      //   if (!this.modal.user.id) { // 注册
      //     // if(!/^[A-Za-z0-9]+$/.test(value)){ // 数字和字母组成
      //     //     callback(new Error(this.$t('l.remark208')));
      //     // }else{
      //     // util.ajax.get('user/checkuserbyusername?username=' + value).then(res => {
      //     //   if (!res.code) {
      //         callback();
      //     //   } else {
      //     //     callback(new Error(this.$t('l.remark13')));
      //     //   }
      //     // })
      //     // }
      //
      //   }
      //   else if (this.modal.user.id) {
      //     util.ajax.get(`user/checkuserupdatebyusername?username=${value}&id=${this.modal.user.id}`).then(res => {
      //       if (!res.code) {
      //         callback();
      //       } else {
      //         callback(new Error(this.$t('l.remark13')));
      //       }
      //     })
      //   }
      //   else callback();
      // },
      //邮箱验证
      validateEmail: (rule, value, callback) => {
        if ((/^\w+@[a-z0-9]+\.[a-z]+$/i).test(value) || !value) {
          callback();
        } else {
          callback(new Error(this.$t('l.remark14')));
        }
      },
      // 验证二次密码输入
      validatePasswrod: (rule, value, callback) => {
        if (this.modal.user.password === this.modal.user.confirmPassword) {
          callback();
        } else {
          callback(new Error(this.$t('l.remark14_c')));
        }
      },
      // 添加电梯 验证
      validateTotalFloor: (rule, value, callback) => {
        if (value <= 0 || value > 64) {
          callback(new Error(this.$t('l.remark89')));
        } else if (!value) {
          callback(new Error(this.$t('l.remark33')));
        } else {
          callback();
        }
      },
      offsetHeight: 0,
      showPwdContent: false,
      passwordType: "password",
      table: {
        data: [],
        loading: false,
        page: {
          current: 1,
          size: 12,
          total: 0,
          sortKey: 'id',
          sortMethod: 'desc',
          keyword: ''
        }
      },
      current: {
        departId: 0,
        extraDeparts: []
      },
      res: {
        sysList: [],//系统res列表
        appList: [],//app res列表
        currentList: [],
        restab: 'device'
      },
      spliter: {
        l_r: 0.3,
        t_b: 0.6
      },
      modal: {
        show: false,
        showAddDevice: false,
        title: this.$t('l.add_user'),
        loading: false,
        addLoading: false,
        currentIndex: -1,
        departTree: [],
        currentDepart: null,
        currentUsers: [],
        user: {
          username: '',
          confirmPassword: '',
          password: '',
          job: '',
          mobile: '',
          email: '',
          j_depart_ids: [],
          job_num: '',
          realname: '',
          birthday: '',
          show_lift_endtime: 0,
          integratedActiveEnabled: 0  // 2024年12月17日 王欢 新版电梯专家BLE6 激活
        },
        filed_list: [], //  地方监管接口必填字段列表
        push_way: [],  // 地方监管接口推送 方式
        device: {
          code: '',
          model: '',
          device_param: {
            rated_speed: "",
            rated_load: "",
            type: 0,
            is_through_door: 0,
          },
          longitude: 116.2529,
          latitude: 39.5427,
          vm_device_id: "",
          type: 0,
          name: '',
          qr_id: 0,
          j_floors: {
            display: [],
            unstop: [],
            negative: 0, // 负楼层
            positive: 0     //正楼层
          },
          j_param: {},
          community_id: 0,
          terminal_id: null,
          terminal_id_curve: null, // 曲线终端
          face_id: null,
          j_location: {},
          factory_cid: 0,
          factory_branch: 0,
          mt_cid: 0,
          j_mt_workers: [],
          j_fzes: [], // 电梯负责人
          ad_cid: 0,
          j_alarm_charger: null,
          j_extra_capacity: [],
          regulatory_field: {way: ''},
          city_id: 0,
          address: '',
          end_time: "",
          brand: '' // 品牌
        },
        device_2g: {
          DEVICE_NUM: '',
          IMSI: '',
          FLOOR: '',
          STATION: '',
          USEDATE: null,
          DOOR: '',
          MANUFACTUREDATE: '',
          XCNJRQ: '',
          Delivery: 0,
          CONTRACT: '',
          INSTALLATION: 0,
          INSTALLATIONMAN: '',
          INSTALLATIONMANMOBILE: '',
          CONSUMER: 0,
          USEOCCASION: '',
          OWNER: '',
          PROPERTY: 0,
          WYRY: '',
          WYDH: '',
        },
        searchLoading: {
          community_id: false,
          factory: false,
          factoryBranch: false,
          mt: false,
          ad: false,
          mt_worker: false,
          alarm_charger: false,
          real_devices: false,
          regionLoading: false,
          fzrLoading: false
        },
        totalFloor: 0,
        alarm_charger_mobile: [],
      },
      modalBind: {
        show: false,
        current_company: {},
        loading: false,
        showAddButton: false,
        ids: [],
        band_user_ids: [],
        searchLoading: false,
        searchUsers: [],

      },
      spin: {
        user: false
      },
      deviceList: {
        table: {
          data: [],
          loading: false,
          page: {
            current: 1,  // 当前页码
            size: 10, // 每页个数
            sizeOptions: [10],
            total: 0,
            sortKey: 'id',
            sortMethod: 'desc',
            keyword: ''
          },
        },
      },
      search: {
        type: {
          label: this.$t('l.device_type'),
          values: [
            {id: 0, name: this.$t('l.lift'), isAuth: true, show: true},
            {id: 3, name: this.$t('l.virtual_lift'), show: true, isAuth: this.$ifauth('fun_vm_device')},
            {id: 4, name: this.$t('l.wcr2G_terminal'), show: true, isAuth: true}
          ],
          selected: []
        },
        device_state: {
          label: this.$t('l.lift_status'),
          values: [
            {id: 0, name: this.$t('l.online')},
            {id: 1, name: this.$t('l.offline')},
            {id: 2, name: this.$t('l.fault')},
            {id: 3, name: this.$t('l.ExpireCount')},
          ],
          selected: [],
        },
        new_old: {
          label: this.$t('l.terminal_type'),
          values: [
            {id: 0, name: 'WCR'},
            {id: 1, name: this.$t('l.smart_screen')},
          ],
          selected: [],
        },
        community_id: {
          label: this.$t('l.community'),
          values: [],
          selected: [],
          handler: this.onCommunityChoosed.bind(this)
        },
        building_id: {
          label: this.$t('l.build_unit'),
          values: [],
          selected: []
        },
        factory_cid: {
          label: this.$t('l.manufacturer'),
          values: [],
          selected: []
        },
        factory_branch: {
          label: this.$t('l.manufacturer_branch'),
          values: [],
          selected: []
        },
        mt_cid: {
          label: this.$t('l.mt_company'),
          values: [],
          selected: []
        },
        j_mt_woker: {
          label: this.$t('l.mt_person'),
          disabled: true,
          values: [],
          selected: []
        },
        j_fzrs: {
          label: this.$t('l.principal'),
          disabled: true,
          values: [],
          selected: []
        },
        ad_cid: {
          label: this.$t('l.ad_company'),
          values: [],
          selected: []
        },
        j_alarm_charger: {
          label: this.$t('l.alarm_mobile'),
          values: [],
          selected: []
        }
      },
    }
  },
  methods: {
    changeShowPwd() {
      this.showPwdContent = !this.showPwdContent;
      this.passwordType = this.showPwdContent ? "text" : "password";
    },
    searchDeviceBlur() {
      this.loadDeviceData(1, this.modal.currentDepart)
    },
    selectUsers() {
      this.loadDeviceData(1, this.modal.currentDepart)
    },
    searchUserBlur() {
      this.loadUserData(1);
    },
    loadUserData(page) {
      // 加载用户列表
      this.table.loading = true;
      util.ajax.get('/user/list', {
        params: {
          departId: this.current.departId,
          page: page || this.table.page.current,
          size: this.table.page.size,
          orderKey: this.table.page.sortKey,
          orderMethod: this.table.page.sortMethod,
          keyword: this.table.page.keyword,
        }
      }).then(res => {
        this.table.loading = false;
        this.setPage(res.data);
      })
    },
    setPage(pageInfo) {
      if (pageInfo) {
        pageInfo.list.forEach(item => util.parseJSONResult(item));
        console.log(pageInfo.list);
        this.table.data = pageInfo.list;
        this.table.page.current = pageInfo.pageNumber;
        this.table.page.total = pageInfo.totalRow;
        console.log(this.table.data);
      }
    },
    pageSizeChange(val) {
      this.table.page.size = val;
      this.loadUserData();
    },
    onDepartSelect(depart) {
      if (depart.id) {
        this.table.loading = true;
        this.deviceList.table.loading = true;
        this.modal.currentDepart = depart;
        this.current.departId = depart.id;
        if (depart.j_auth_list) {
          if (depart.j_extra_auth) depart.j_auth_list.concat(depart.j_extra_auth);
        }
        this.res.currentList = [...new Set(depart.j_auth_list)];
        this.loadUserData(1);
        this.loadDeviceData(1, depart);
      } else {
        this.modal.currentDepart = null;
        this.current.departId = 0;
        this.res.currentList = [];
      }
    },
    getResources() {
      let language = localStorage.getItem("language") ? localStorage.getItem("language") : 'zh-CN';
      util.ajax.get('/res/getlist', {
        params: {
          language: language
        }
      }).then((res) => {
        if (language == 'en-US') {
          res.data.sys.forEach(elem => {
            elem.title = elem.res_name_en_us;
            this.setEnUsRes(elem);
          });
          res.data.app.forEach(elem => {
            elem.title = elem.res_name_en_us;
            this.setEnUsRes(elem);
          });
        }
        this.res.sysList = res.data.sys;
        this.res.appList = res.data.app;
      });
    },
    setEnUsRes(elem) {
      elem.title = elem.res_name_en_us;
      if (elem.children) {
        elem.children.forEach(item => {
          item.title = item.res_name_en_us;
          return this.setEnUsRes(item);
        })
      }
      return elem;
    },
    changeRegulatoryField() {
      if (this.modal.push_way.length) {
        let a = this.modal.push_way.find(e => {
          return e.label === this.modal.device.regulatory_field.way;
        })
        if (a) {
          this.modal.filed_list = a.j_config;
        }
      }
    },
    onSubmit() {
      this.$refs.modal_user.validate(valid => {
        if (valid) {
          if (this.modal.user.birthday) this.modal.user.birthday = new Date(this.modal.user.birthday).pattern("yyyy-MM-dd");
          delete this.modal.user.confirmPassword;
          let user = util.deepCopy(this.modal.user);
          if (!user.password) {
            delete user.password;
          }

          // 2025年2月5日  邮箱和手机号必须有一个
          if (!user.mobile && !user.email) {
            this.$Message.error(this.$t('l.remark246'));
            return
          }

          this.modal.loading = true;
          if (user.id) {
            // 加入preEdit() 中缓存的当前公司不可见的部门id并去重（未作修改时，不变更）
            user.updateDepartIds = user.j_depart_ids;  // 2026年2月26日 王欢 新传个参数 需要知道本次哪些做了更新
            user.j_depart_ids = [...new Set(user.j_depart_ids.concat(this.current.extraDeparts))];
            util.ajax.put('/user/update', user).then(res => {
              this.modal.loading = false;
              if (!res.code) {
                this.modal.show = false;
                this.loadUserData();
                // this.table.data.splice(this.modal.currentIndex, 1, this.modal.user);
                // this.modal.currentIndex = -1;
                this.$Message.success(this.$t('l.edit_success'))
              }
            }).then(() => {
              if (this.$store.state.user.user.id == user.id) {
                // 编辑的是自己 并 自己添加了新的部门或者公司 删除自己的缓存重新封装$store
                util.getAuth();
              }
            })
          } else {
            util.ajax.post('/user/add', user).then(res => {
              this.modal.loading = false;
              if (!res.code) {
                this.modal.show = false;
                this.loadUserData();
                this.$Message.success(this.$t('l.add_success'))
              }
            })
          }
        } else {
          this.$Message.error(this.$t('l.remark24'))
        }
      })
    },
    chooseRadio(v) {
      let item = this.modal.push_way.find((e) => {
        return e.label === v;
      })
      if (item) {
        this.modal.filed_list = item.j_config;
        this.modal.current_describe = item.describe
      }

    },
    //  选择绑定部门
    onSelectBindDepart(depart) {
      this.modalBind.current_company = depart;
    },
    onSubmitBind() {
      if (this.modalBind.current_company.id == this.modal.currentDepart.id) {
        this.$Message.error(this.$t("l.remark220"));
        return;
      }
      this.modalBind.loading = true;
      let ids = this.modalBind.ids;
      let is_manual_bind = this.modalBind.current_company.is_manual_bind;
      let j_demo_devices = this.modalBind.current_company.j_demo_devices;
      if (is_manual_bind == 1 && j_demo_devices) { // 当前设备是手动绑定电梯
        ids = [...new Set(j_demo_devices.concat(ids))];
      }

      util.ajax.post("device/batchbind", {
        ids: ids,
        company: this.modalBind.current_company
      }).then(res => {
        this.modalBind.loading = false;
        if (!res.code) {
          this.modalBind.show = false;
          this.modalBind.current_company.j_demo_devices = ids;
          this.$Message.success(this.$t("l.success"));
          this.loadDeviceData(1, this.modal.currentDepart)
          if (is_manual_bind == 1) this.$refs.depart_tree.loadTree();
        }
      })
    },
    setSelected(departs) {
      if (!this.modal.user.j_depart_ids.length) return;
      departs.forEach(depart => {
        if (this.modal.user.j_depart_ids.includes(depart.id)) {
          depart.checked = true;
        }
        depart.expand = true;
        if (depart.children) this.setSelected(depart.children);
      })
    },
    setTreeMap(tree, map) {
      tree.forEach(node => {
        map[node.id.toString()] = node;
        if (node.children) this.setTreeMap(node.children, map);
      })
    },
    loadRegionData() {
      this.modal.push_way = [];
      util.ajax.get('/push/accesspermit').then(res => {
        if (res.data && res.data.length) {
          this.modal.push_way = res.data.map(elem => {
            elem.j_factory = JSON.parse(elem.j_factory);
            elem.j_config = JSON.parse(elem.j_config);
            return elem;
          });
        }
      })
    },
    preEdit(user) {
      this.modal.show = true;
      this.current.extraDeparts = [];
      this.modal.title = this.$t('l.user_info');
      let accessibleDeparts = Object.keys(this.departMap).map(idStr => parseInt(idStr));
      this.modal.user = util.deepCopy(user);
      if (this.showpwd) {
        this.modal.user.confirmPassword = this.modal.user.password;
      }
      util.parseJSON(this.modal.user.j_depart_ids).forEach(id => {
        if (!accessibleDeparts.includes(id)) this.current.extraDeparts.push(id);
      })
      this.$refs['modal_user'].resetFields();
      this.modal.departTree = util.deepCopy(this.$refs.depart_tree.departTree);
      this.setSelected(this.modal.departTree);
    },
    onTotalFloorChange(value, upORdown) {
      this.modal.totalFloor = this.modal.device.j_floors.positive + this.modal.device.j_floors.negative;
      let originSize = this.modal.device.j_floors.display.length; // 修改之前的总楼层
      if (this.modal.device.device_param.is_through_door) {
        // 根据修改之前的楼层显示，分组
        let oriFloor = originSize / 2; // 修改之前 贯通门总楼层
        let partA = this.modal.device.j_floors.display.slice(0, oriFloor);
        let partB = this.modal.device.j_floors.display.slice(-oriFloor);

        let partAdown = partA.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
        let partAup = partA.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
        let partBdown = partB.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));
        let partBup = partB.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (oriFloor - this.modal.device.j_floors.positive));

        if (upORdown > 0) {
          if (partAup.length < value) {
            for (let i = partAup.length + 1; i <= value; i++) {
              partAup.push(i.toString() + 'A');
              partBup.push(i.toString() + 'B');
            }
          } else if (partAup.length > value) {
            partAup.splice(value, partAup.length - value);
            partBup.splice(value, partBup.length - value);
          }
        } else if (upORdown < 0) {
          if (partAdown.length < value) {
            for (let i = partAdown.length + 1; i <= value; i++) {
              partAdown.unshift((-i).toString() + 'A');
              partBdown.unshift((-i).toString() + 'B');
            }
          } else if (partAdown.length > value) {
            partAdown.splice(0, partAdown.length - value);
            partBdown.splice(0, partBdown.length - value);
          }
        }

        this.modal.device.j_floors.display = partAdown.concat(partAup).concat(partBdown).concat(partBup)
      } else {
        let partDOWN = this.modal.device.j_floors.display.slice(0, upORdown > 0 ? this.modal.device.j_floors.negative : (originSize - this.modal.device.j_floors.positive));
        let partUP = this.modal.device.j_floors.display.slice(upORdown > 0 ? this.modal.device.j_floors.negative : (-(originSize - this.modal.device.j_floors.positive)));
        if (upORdown > 0) {
          if (partUP.length < value) {
            for (let i = partUP.length + 1; i <= value; i++) {
              this.modal.device.j_floors.display.push(i.toString());
            }
          } else if (partUP.length > value) {
            this.modal.device.j_floors.display.splice(value + this.modal.device.j_floors.negative, partUP.length - value);
          }
        } else { // 修改负楼层
          if (partDOWN.length < value) { // 新的负楼层多
            for (let i = partDOWN.length + 1; i <= value; i++) {
              this.modal.device.j_floors.display.unshift((-i).toString());
            }
          } else if (partDOWN.length > value) { // 新的负楼层少
            this.modal.device.j_floors.display.splice(0, partDOWN.length - value);
          }
        }
      }
    },
    preDelete(user) {
      console.log("当前公司", this.modal.currentDepart);
      if (this.$store.state.user.user.id === user.id) {
        this.$Message.error(this.$t("l.remark226"));
        return;
      }
      this.$Modal.confirm({
        title: this.$t('l.warn'),
        content: this.$t('l.hint16') + "--" + user.username,
        okText: this.$t('l.delete'),
        cancelText: this.$t('l.cancel'),
        onOk: () => {
          // 2026年2月27日 王欢 删除用户时 ，需要知道当前操作的是哪个公司
          util.ajax.post("/user/remove", {userId:user.id,currentDepartId:this.modal.currentDepart.id}).then(res => {
            if (!res.code) {
              this.$Message.success(this.$t('l.delete_success'));
              this.loadUserData(1);
            }
          });
        }
      });
    },
    onAddDevice() {
      this.search.type.values[1].show = true;
      this.modal.showAddDevice = true;
      let d = this.modal.device = {
        type: 0,
        name: '',
        end_time: "",
        j_floors: {
          display: [],
          unstop: [],
          negative: 0,
          positive: 0
        },
        longitude: 0,
        latitude: 0,
        j_param: {},
        community_id: 0,
        vm_device_id: '',
        qr_id: 0,
        terminal_id: '',
        terminal_id_curve: '',
        j_location: {},
        factory_cid: 0,
        factory_branch: 0,
        mt_cid: 0,
        j_mt_workers: [],
        j_fzrs: [],
        ad_cid: 0,
        j_alarm_charger: null,
        device_param: {
          rated_speed: "",
          rated_load: "",
          type: 0,
          is_through_door: 0,
        },
        regulatory_field: {},
        city_id: 0,
        address: '',
        brand: ''
      }
      this.modal.alarm_charger_mobile = [];
      this.modal.fzrs_mobile = [];
      this.modal.mt_worker_mbile = []
      this.modal.totalFloor = 0;
      let myCompany = this.$store.state.user.user.company;
      switch (myCompany.role_id) {
          // 如果是电梯厂
        case roleTypes.ELEV_FACTORY:
          if (myCompany.type == 0) { // 公司
            d.factory_cid = myCompany.id;
          } else {
            d.factory_cid = myCompany.pid;
            d.factory_branch = myCompany.id;
          }
          break;
        case roleTypes.MT_COMPANY:
          d.mt_cid = myCompany.id;
          this.remoteSearchMTWorker(myCompany.id);
          break;
        case roleTypes.AD:
          d.ad_cid = myCompany.id;
          break;
      }
      this.modal.filed_list = []
      this.modal.choosedLocationIds = []
    },
    select_e(mobile) {
      let v = [];
      this.search.j_alarm_charger.values.forEach((elem) => {
        if (mobile.indexOf(elem.mobile) > -1) {
          v.push(elem);
        }
      });
      this.getData[0].j_alarm_charger = [];
      if (v && v.length) {
        v.forEach(item => {
          this.getData[0].j_alarm_charger.push({
            mobile: item.mobile,
            name: item.name
          });
        });
      }
    },
    select_mt_workers(mobile) {
      let v = [];
      this.search.j_mt_woker.values.forEach((elem) => {
        if (mobile.indexOf(elem.mobile) > -1) {
          v.push(elem);
        }
      });
      this.getData[0].j_mt_workers = [];
      if (v && v.length) {
        v.forEach(item => {
          this.getData[0].j_mt_workers.push({
            mobile: item.mobile,
            name: item.name
          });
        });
      }
    },
    remoteSearchCommunity(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.community_id = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_community',
          field: 'name',
          value: '%' + value + '%'
        }
      }).then(res => {
        this.modal.searchLoading.community_id = false;
        let existed = this.search.community_id.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.community_id.values.push(comm)
          }
        })
      })
    },
    remoteSearchFactoryBranch(value, action) {
      value = value.trim();
      if (!action && !value) return;
      if (!this.modal.device.factory_cid) return;
      this.modal.searchLoading.factoryBranch = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value + '%',
          other: JSON.stringify({
            pid: this.modal.device.factory_cid,
            type: 0,
            role_id: roleTypes.ELEV_FACTORY
          })
        }
      }).then(res => {
        this.modal.searchLoading.factoryBranch = false;
        if (action === 'replace') this.search.factory_branch.values = [];
        let existed = this.search.factory_branch.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.factory_branch.values.unshift(comm)
          }
        })
      })
    },
    remoteSearchFactory(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.member = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value.trim() + '%',
          other: JSON.stringify({
            pid: 0,
            type: 0,
            role_id: roleTypes.ELEV_FACTORY
          })
        }
      }).then(res => {
        this.modal.searchLoading.member = false;
        let existed = this.search.factory_cid.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.factory_cid.values.push(comm)
          }
        })
      })
    },
    remoteSearchMT(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.mt = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value.trim() + '%',
          other: JSON.stringify({
            type: 0,
            role_id: roleTypes.MT_COMPANY
          })
        }
      }).then(res => {
        this.modal.searchLoading.mt = false;
        let existed = this.search.mt_cid.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.mt_cid.values.push(comm)
          }
        })
      })
    },
    remoteSearchMTWorker(value) {
      // if (!value) {
      //   return new Promise((resolve, reject) => {
      //     resolve()
      //   });
      // }
      // let list = this.search.j_mt_woker.values;
      // list.splice(0, list.length);
      // if (!value) return;
      // this.modal.searchLoading.mt_worker = true;
      // return util.ajax.get('/user/listofcompany', {
      //   params: {
      //     companyId: value
      //   }
      // }).then(res => {
      //   this.modal.searchLoading.mt_worker = false;
      //   // res.data.forEach(worker => {
      //   //     worker.name = worker.realname;
      //   // })
      //   // list.push(...res.data);
      // })
    },
    remoteSearchAD(value) {
      if (!value.trim()) return;
      this.modal.searchLoading.ad = true;
      util.ajax.get('/device/searchoption', {
        params: {
          table: 't_depart',
          field: 'name',
          value: '%' + value + '%',
          other: JSON.stringify({
            type: 0,
            role_id: roleTypes.AD
          })
        }
      }).then(res => {
        this.modal.searchLoading.ad = false;
        let existed = this.search.ad_cid.values.map(item => item.id)
        res.data.forEach(comm => {
          if (!existed.includes(comm.id)) {
            this.search.ad_cid.values.push(comm)
          }
        })
      })
    },

    loadOptions() {
      this.search.community_id.values = [];
      this.search.j_alarm_charger.values = [];
      this.search.j_fzrs.values = []
      this.search.j_mt_woker.values = [];
      this.search.factory_cid.values = [];
      this.search.factory_branch.values = [];
      this.search.mt_cid.values = [];
      this.search.ad_cid.values = [];

      // 2025年6月27日  拆分请求 一个请求有点慢  王欢

      util.ajax.get('/device/getVCompany').then(res => {
        if (res.data) {
          this.search.factory_cid.values = [];
          this.search.factory_branch.values = [];
          this.search.mt_cid.values = [];
          this.search.ad_cid.values = [];
          let myCompany = this.$store.state.user.user.company;
          if (!res.data.company.map(comp => comp.id).includes(myCompany.id)) {
            res.data.company.push(myCompany);
          }
          res.data.company.map(company => {
            switch (company.role_id) {
              case roleTypes.AD:
                this.search.ad_cid.values.push(company);
                break;
              case roleTypes.MT_COMPANY:
                this.search.mt_cid.values.push(company);
                break;
              case roleTypes.ELEV_FACTORY:
              case roleTypes.CONSUMER:
                if (!company.pid) this.search.factory_cid.values.push(company);
                else this.search.factory_branch.values.push(company);
                break;
            }
          })
        }
      })

      util.ajax.get('/device/getVCommunity').then(res => {
        if (res.data) {
          this.search.community_id.values = res.data.community;
        }

      })

      util.ajax.get('/device/getVAlarmAndFzrAndMt').then(res => {
        if (res.data) {
          this.search.j_alarm_charger.values = [];
          this.search.j_fzrs.values = []
          this.search.j_mt_woker.values = [];
          //所有告警人
          res.data.alarm_chargers.forEach(man => {
            if (man && man.mobile) {
              man.id = man.mobile;
              if (!this.chargerMap[man.mobile]) this.search.j_alarm_charger.values.push(man);
            }
          });
          //所有负责人
          if (res.data.fzrs) {
            res.data.fzrs.forEach(mans => {
              let manArr = JSON.parse(mans);
              if (manArr && manArr.length) {
                manArr.forEach(man => {
                  if (man && man.mobile) {
                    man.id = man.mobile;
                    if (!this.fzrMap[man.mobile]) this.search.j_fzrs.values.push(man);
                  }
                });
              }
            });
          }
          // 所有维保人员
          res.data.j_mt_workers.forEach(mans => {
            let manArr = JSON.parse(mans);
            if (manArr && manArr.length) {
              manArr.forEach(man => {
                if (man && man.mobile) {
                  man.id = man.mobile;
                  if (!this.mtWorkersMap[man.mobile]) this.search.j_mt_woker.values.push(man);
                }
              });
            }
          });

        }
      })

    },

    // loadOptions() {
    //     util.ajax.get('/device/getalloptions').then(res => {
    //         if (res.data) {
    //             this.search.community_id.values = res.data.community;
    //             this.search.j_alarm_charger.values = [];
    //             this.search.j_fzrs.values = []
    //             this.search.j_mt_woker.values = [];
    //             //所有告警人
    //             res.data.alarm_chargers.forEach(man => {
    //                         if (man && man.mobile) {
    //                             man.id = man.mobile;
    //                             if (!this.chargerMap[man.mobile]) this.search.j_alarm_charger.values.push(man);
    //                         }
    //             });
    //             //所有负责人
    //             if (res.data.fzrs) {
    //                 res.data.fzrs.forEach(mans => {
    //                     let manArr = JSON.parse(mans);
    //                     if (manArr && manArr.length) {
    //                         manArr.forEach(man => {
    //                             if (man && man.mobile) {
    //                                 man.id = man.mobile;
    //                                 if (!this.fzrMap[man.mobile]) this.search.j_fzrs.values.push(man);
    //                             }
    //                         });
    //                     }
    //                 });
    //             }
    //             // 所有维保人员
    //             res.data.j_mt_workers.forEach(mans => {
    //                 let manArr = JSON.parse(mans);
    //                 if (manArr && manArr.length) {
    //                     manArr.forEach(man => {
    //                         if (man && man.mobile) {
    //                             man.id = man.mobile;
    //                             if (!this.mtWorkersMap[man.mobile]) this.search.j_mt_woker.values.push(man);
    //                         }
    //                     });
    //                 }
    //             });
    //             this.search.factory_cid.values = [];
    //             this.search.factory_branch.values = [];
    //             this.search.mt_cid.values = [];
    //             this.search.ad_cid.values = [];
    //             let myCompany = this.$store.state.user.user.company;
    //             if (!res.data.company.map(comp => comp.id).includes(myCompany.id)) {
    //                 res.data.company.push(myCompany);
    //             }
    //             res.data.company.map(company => {
    //                 switch (company.role_id) {
    //                     case roleTypes.AD:
    //                         this.search.ad_cid.values.push(company);
    //                         break;
    //                     case roleTypes.MT_COMPANY:
    //                         this.search.mt_cid.values.push(company);
    //                         break;
    //                     case roleTypes.ELEV_FACTORY:
    //                     case roleTypes.CONSUMER:
    //                         if (!company.pid) this.search.factory_cid.values.push(company);
    //                         else this.search.factory_branch.values.push(company);
    //                         break;
    //                 }
    //             })
    //         }
    //     })
    // },
    addAlarm(charger) {
      this.search.j_alarm_charger.values.push(charger);
      this.modal.alarm_charger_mobile.push(charger.mobile);
    },
    addFzr(fzr) {
      this.search.j_fzrs.values.push(fzr);
      this.modal.fzrs_mobile.push(fzr.mobile);
    },
    addMtWorker(mt) {
      this.search.j_mt_woker.values.push(mt);
      this.modal.mt_worker_mbile.push(mt.mobile);
    },
    addElevatorSelectAlarmUser(mobiles) {
      if (mobiles.length > 2) {
        this.modal.alarm_charger_mobile = mobiles.slice(0, 2);
        this.$Message.error(this.$t('l.remark193'));
        return;
      }
      this.modal.alarm_charger_mobile = mobiles;

    },
    alarmDesc() {
      this.$Modal.info({
        title: this.$t("l.alarm_description"),
        okText: this.$t("l.close"),
        render: (h) => {
          return h('div', [
            h("p", {}, "1、" + this.$t("l.explain18")),
            h("p", {}, "2、" + this.$t("l.explain19")),
            // h("p", {}, "3、" + this.$t("l.explain20")),
            h("p", {}, "4、" + this.$t("l.explain23")),
            h("p", {}, "5、" + this.$t("l.explain24")),

          ])
        },
      })
    },
    addAlarmCharger() {
      if (this.modal.alarm_charger_mobile.length >= 2) {
        this.$Message.error(this.$t("l.remark193"))
        return;
      }

      let charger = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', this.$t('l.add_alarm_mobile')),
            h('Form', {
                  props: {
                    'label-width': 80
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: charger.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        charger.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: charger.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        charger.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          if (!charger.name || !charger.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(charger.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }
          this.search.j_alarm_charger.values.push(charger);
          this.modal.alarm_charger_mobile.push(charger.mobile);
        }
      })
    },
    addFzrs() {
      let fzr = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', this.$t('l.add_principal')),
            h('Form', {
                  props: {
                    'label-width': 80
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: fzr.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        fzr.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: fzr.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        fzr.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          if (!fzr.name || !fzr.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(fzr.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }
          this.search.j_fzrs.values.push(fzr);
          this.modal.fzrs_mobile.push(fzr.mobile);
        }
      })
    },
    // 新建维保负责人
    addMtWorkers() {
      let mt = {
        name: '',
        mobile: ''
      }
      this.$Modal.confirm({
        render: (h) => {
          return h('div', [
            h('h3', this.$t('l.add_maintenance')),
            h('Form', {
                  props: {
                    'label-width': 80
                  }
                },
                [
                  h('FormItem', {
                    props: {
                      label: this.$t('l.name')
                    }
                  }, [h('Input', {
                    props: {
                      value: mt.name,
                      placeholder: this.$t('l.remark39')
                    },
                    on: {
                      input: (val) => {
                        mt.name = val
                      }
                    }
                  })]),
                  h('FormItem', {
                    props: {
                      label: this.$t('l.mobile')
                    }
                  }, [h('Input', {
                    props: {
                      value: mt.mobile,
                      placeholder: this.$t('l.remark41')
                    },
                    on: {
                      input: (val) => {
                        mt.mobile = val
                      }
                    }
                  })])
                ])
          ])
        },
        onOk: () => {
          if (!mt.name || !mt.mobile) {
            this.$Message.warning(this.$t('l.remark90'));
            return;
          }
          if (!(/^1[3456789]\d{9}$/.test(mt.mobile))) {
            this.$Message.warning(this.$t('l.remark91'));
            return;
          }
          this.search.j_mt_woker.values.push(mt);
          this.modal.mt_worker_mbile.push(mt.mobile);
        }
      })
    },
    onCommunityChoosed(isAdd, index) {
      if (isAdd && this.search.community_id.selected.length === 1) {
        let comm = this.search.community_id.values[index];
        comm.j_buildings = util.parseJSON(comm.j_buildings, []);
        this.search.building_id.values = comm.j_buildings;
      } else {
        this.search.building_id.values = [];
      }
      this.search.building_id.selected = [];
    },
    preJumpAddCommunity() {
      this.$Modal.confirm({
        title: this.$t('l.prompt'),
        content: this.$t('l.remark93'),
        okText: this.$t('l.confirm'),
        cancelText: this.$t('l.cancel'),
        onOk: () => {
          this.$router.push({name: 'page_community'})
        }
      })
    },
    onCommunitySelect(commId) { // 编辑小区 如果更换小区那么新的绑定地址也得更换
      if (!commId) return;
      let community = this.search.community_id.values.find(comm => {
        return comm.id === commId;
      })

      this.modal.choosedLocationIds = []
      if (community) {

        if (!this.modal.device.address) { // 绑定小区了，但是没有详细device.address字段 为null
          if (community.j_region) {
            community.j_region = util.parseJSON(community.j_region);
            this.modal.device.address = community.j_region.province.name +
                community.j_region.city.name + (community.j_region.area ? community.j_region.area.name + (community.address ? community.address : '') : '')
          }
        } else {
          if (this.modal.device.type == 3) { // 查询真实电梯
            util.ajax.get("device/getrealdevice", {
              params: {
                cid: this.modal.device.community_id,
                bid: 0,
                uid: 0,
                type: this.modal.device.type
              }
            }).then(res => {
              this.realDevices = []
              if (!res.code && res.data) {
                res.data.forEach(item => {
                  if (item.terminal_id) {
                    this.realDevices.push(item)
                  }
                })
              }
            })
          }
        }
        this.modal.locationTree = util.parseJSON(community.j_buildings, []);
        this.modal.locationTree.forEach(b => {
          b.value = b.id;
          b.label = b.name;
          b.children = b.units;
          b.units.forEach(u => {
            u.value = u.id;
            u.label = u.name;
            u.children = u.doors;
            u.doors.forEach(d => {
              d.value = d.id;
              d.label = d.name;
            })
          })
        })
      }
    },
    changeRadio() {
      this.$refs['modal'].resetFields();
    },
    onLocationSelect(value, selected) {
      let location = this.modal.device.j_location = {};
      if (selected[0]) location.building = {
        id: selected[0].id,
        name: selected[0].name
      };
      if (selected[1]) location.unit = {
        id: selected[1].id,
        name: selected[1].name
      };
    },
    switch_change_through(val) {
      if (val) {
        if (this.modal.totalFloor > 32) {
          this.$Modal.warning({
            content: this.$t('l.remark172')
          })
          this.$refs.switch_change_through.toggle({
            preventDefault: () => {
            }
          });
          return;
        }
        this.modal.device.device_param.is_through_door = 1;
        let partA = [];
        let partB = [];
        for (let i = 1; i <= this.modal.device.j_floors.negative; i++) {
          partA.unshift((-i).toString() + 'A');
          partB.unshift((-i).toString() + 'B');
        }
        for (let i = 1; i <= this.modal.device.j_floors.positive; i++) {
          partA.push(i.toString() + 'A');
          partB.push(i.toString() + 'B');
        }

        this.modal.device.j_floors.display = partA.concat(partB);
      } else {
        this.modal.device.device_param.is_through_door = 0;
        this.modal.device.j_floors.display = [];
        for (let i = 1; i <= this.modal.device.j_floors.negative; i++) {
          this.modal.device.j_floors.display.unshift((-i).toString());
        }
        for (let i = 1; i <= this.modal.device.j_floors.positive; i++) {
          this.modal.device.j_floors.display.push(i.toString());
        }
      }
    },
    preAdd() {
      this.modal.user = {
        username: '',
        j_depart_ids: [this.current.departId],
        job_num: '',
        job: '',
        mobile: '',
        email: '',
        realname: '',
        show_lift_endtime: 0,
        birthday: '',
        integratedActiveEnabled: 0
      }
      this.$refs['modal_user'].resetFields();
      this.modal.departTree = util.deepCopy(this.$refs.depart_tree.departTree);
      this.setSelected(this.modal.departTree);
      this.modal.title = this.$t('l.add_user');
      this.modal.show = true;
    },
    //  远程搜索用户电话+姓名

    onAddSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.modal.device.device_param.is_through_door) { //
            if (this.modal.totalFloor > 32) {
              this.$Message.error(this.$t('l.hint43'))
              return;
            }
          }
          let device = this.modal.device;
          if (device.end_time) device.end_time = typeof device.end_time === 'string' ? device.end_time : device.end_time.pattern("yyyy-MM-dd");
          else device.end_time = null;
          delete device.community_name;
          delete device.transtionShow;
          delete device.params_settings;
          delete device.terminal_type;
          delete device.factory_name;
          delete device.isExpire; // 用于判断是否过期
          delete device.rolling_code_index;
          delete device.broken;
          delete device.caddress;
          delete device.current_status;
          if (this.modal.alarm_charger_mobile.length) { // 告警人最多填写五位
            if (this.modal.alarm_charger_mobile.length >= 2) {
              this.$Message.error(this.$t('l.remark193'))
              return;
            }
            device.j_alarm_charger = [];
            this.modal.alarm_charger_mobile.forEach(mobile => {
              let charger = this.chargerMap[mobile];
              if (charger) {
                device.j_alarm_charger.push({
                  mobile: charger.mobile,
                  name: charger.name
                });
              } else {
                device.j_alarm_charger = []
              }
            })
          } else {
            device.j_alarm_charger = null;
          }
          if (this.modal.fzrs_mobile.length) { // 负责人
            device.j_fzrs = [];
            this.modal.fzrs_mobile.forEach(mobile => {
              let fzr = this.fzrMap[mobile];
              if (fzr) {
                device.j_fzrs.push({
                  mobile: fzr.mobile,
                  name: fzr.name
                });
              }
            })
          } else {
            device.j_fzrs = null;
          }
          if (this.modal.mt_worker_mbile.length) { // 维保人
            device.j_mt_workers = [];
            this.modal.mt_worker_mbile.forEach(mobile => {
              let mt = this.mtWorkersMap[mobile];
              if (mt) {
                device.j_mt_workers.push({
                  mobile: mt.mobile,
                  name: mt.name
                });
              }
            })
          } else {
            device.j_mt_workers = null;
          }
          if (!device.terminal_id) device.terminal_id = null
          if (!device.face_id) device.face_id = null
          device.j_param = device.j_param ? device.j_param : {}

          if (device.terminal_id && ((device.terminal_id.startsWith("L") || device.terminal_id.startsWith("T") || device.terminal_id.startsWith("W")) && device.terminal_id.length != 16)) {
            this.$Message.error(this.$t("l.remark202"));
            return;
          }
          if (device.type == 4) {
            let device_2G = this.modal.device_2g;
            if (!device_2G.FLOOR) {
              this.$Message.error(this.$t('l.remark24'));
              return;
            }
            if (!device_2G.DEVICE_NUM) {
              this.$Message.error(this.$t('l.remark24'));
              return;
            }
            if (!device.terminal_id || !device_2G.IMSI) {
              this.$Message.error("请填写IMSI");
              return;
            }
            if (device.terminal_id.length != 14) {
              this.$Message.error("BS号不合法");
              return;
            }
            if (device_2G.USEDATE) {
              device_2G.USEDATE = new Date(device_2G.USEDATE).pattern("yyyy-MM-dd HH:mm:ss")
            }
            if (device_2G.MANUFACTUREDATE) {
              device_2G.MANUFACTUREDATE = new Date(device_2G.MANUFACTUREDATE).pattern("yyyy-MM-dd HH:mm:ss")
            }
            if (device_2G.XCNJRQ) {
              device_2G.XCNJRQ = new Date(device_2G.XCNJRQ).pattern("yyyy-MM-dd HH:mm:ss")
            }
            Object.assign(device, device_2G);
          }
          this.modal.addLoading = true;
          util.ajax.post('/device/add', device).then(res => {
            this.modal.addLoading = false;
            if (!res.code) {
              this.modal.showAddDevice = false;
              this.loadDeviceData(this.deviceList.table.page.current, this.modal.currentDepart);
              this.$Message.success(this.$t('l.add_success'))
            }
          }).catch(e => {
            this.modal.addLoading = false;
          })
        } else {
          this.$Message.error(this.$t('l.remark24'));
        }
      })
    },
    //  分配电梯
    assignedTo() {
      var tableDom = this.$refs.visibleDevice.$refs.table;
      this.modalBind.ids = [];
      if (tableDom.getSelection().length > 0) {
        for (var row of tableDom.getSelection()) {
          this.modalBind.ids.push(row.id);
        }
      } else {
        this.$Message.warning(this.$t("l.remark216"));
        return;
      }
      //  查看是否选择了分配的厂商分配电梯
      if (!this.current.departId && this.modal.currentDepart) {
        this.$Message.warning(this.$t("l.remark217"));
      }
      this.modalBind.show = true;
    },
    //    移除电梯
    removeTo() {
      var tableDom = this.$refs.visibleDevice.$refs.table;
      let ids = [];
      if (tableDom.getSelection().length > 0) {
        for (var row of tableDom.getSelection()) {
          ids.push(row.id);
        }
      } else {
        this.$Message.warning(this.$t("l.remark221"));
        return;
      }
      //  查看是否选择了分配的厂商分配电梯
      if (!this.current.departId && this.modal.currentDepart.pid) {
        this.$Message.warning(this.$t("l.remark223"));
        return;
      }

      // 取消绑定设备
      this.$Modal.confirm({
        title: this.$t('l.warn'),
        content: this.$t('l.remark225'),
        onOk: () => {
          let newIds = [];
          let is_manual_bind = this.modal.currentDepart.is_manual_bind;
          let j_demo_devices = this.modal.currentDepart.j_demo_devices;
          if (is_manual_bind === 1 && j_demo_devices) { // 当前设备是手动绑定电梯
            newIds = j_demo_devices.filter(id => ids.indexOf(id) === -1);
          } else {
            newIds = ids;
          }
          util.ajax.post("device/batchunbind", {
            ids: newIds,
            current_company: this.modal.currentDepart
          }).then(res => {
            if (!res.code) {
              this.$Message.success(this.$t("l.success"));
              this.loadDeviceData(1, this.modal.currentDepart)
              if (is_manual_bind == 1) this.$refs.depart_tree.loadTree();
            }
          })

        }
      })
    },
    //    管理员加载role列表
    loadRoleData() {
      util.ajax.get('/role/getlist').then(res => {
        let roleList = res.data.map(item => {
          item.j_auth_list = JSON.parse(item.j_auth_list);
          return item;
        })
        this.$store.commit('setMyRoles', roleList);
      })
    },
    //     加载设备列表
    loadDeviceData(page, otherParam) {
      let params = {
        page: page || this.deviceList.table.page.current,
        size: this.deviceList.table.page.size,
        orderKey: this.deviceList.table.page.sortKey,
        orderMethod: this.deviceList.table.page.sortMethod,
        noStatus: true,
        keyword: this.deviceList.table.page.keyword,
        currentUsers: this.modal.currentUsers
      };
      if (otherParam) {
        params["company"] = otherParam;
      }
      this.deviceList.table.loading = true;
      util.ajax.post('/device/devicelistofuser', params).then(res => {
        this.deviceList.table.loading = false;
        this.deviceList.table.data = res.data.list;
        this.deviceList.table.page.current = res.data.pageNumber;
        this.deviceList.table.page.total = res.data.totalRow;
      })
    }
  },
  computed: {
    showPushFiled() {
      return this.modal.device.regulatory_field && this.modal.device.regulatory_field.way && this.modal.device.terminal_id
    },
    departMap() {
      let map = {};
      this.setTreeMap(this.$store.state.app.departTree, map);
      return map;
    },
    showpush() {
      return this.modal.push_way && this.modal.push_way.length && (this.modal.device.terminal_id && !this.modal.device.terminal_id.startsWith("E"));
    },
    getDeviceTypeList() {
      return [
        {id: 0, lable: this.$t('l.lift_type1')},
        {id: 1, lable: this.$t('l.lift_type2')},
        {id: 2, lable: this.$t('l.lift_type3')},
        {id: 3, lable: this.$t('l.lift_type4')},
      ]
    },
    currentUserDirectInCompany() {
      let user = this.$store.state.user.user;
      if (!user) return null;
      return user.role === 'ROOT' || user.departs.find(depart => {
        return depart.id === user.current_company;
      })
    },
    showpwd() {
      let user = this.$store.state.user;
      if (user.isROOT) return true;
      return user.user.companies.find(company => {
        if (company.pid === 0) { // 根级别公司
          return user.user.current_company == company.id;
        }
      })
    },
    getColumns() {
      return [
        {
          title: this.$t('l.name'),
          key: 'realname'
        },
        {
          title: this.$t('l.company') + ' / ' + this.$t('l.department'),
          key: 'j_depart_ids',
          render: (h, data) => {
            if (!this.departMap || !Object.keys(this.departMap).length) return h('span', data.row.j_depart_ids);
            let departNames = [];
            data.row.j_depart_ids.forEach(id => {
              let depart = this.departMap[id.toString()]
              if (!depart) return;
              let departName = depart.name;
              if (id !== depart.company_id) {
                departName = this.departMap[depart.company_id.toString()].name + ' / ' + departName;
              }
              departNames.push(departName)
            })
            let nameStr = departNames.join(', \n');

            let departNameEles = [];
            if (departNames.length < 2) departNameEles.push(h('div', departNames[0]));
            else {
              departNameEles.push(h('div', departNames[0] + '…'))
              departNameEles.push(h('div', {
                class: 'clickable',
                on: {
                  click: () => {
                    this.$Modal.info({
                      title: `${data.row.realname} ` + this.$t('l.hint62'),
                      render: () => {
                        let lis = [];
                        departNames.forEach(name => {
                          lis.push(h('li', name))
                        })
                        return h('ul', lis)
                      }
                    })
                  }
                }
              }, departNames.length + ' ' + this.$t('l.depart_num')))
            }
            return h('span', {
              attrs: {
                title: nameStr
              }
            }, departNameEles);
          }
        },
        {
          title: this.$t('l.position'),
          key: 'job'
        },
        {
          title: this.$t('l.job_num'),
          key: 'job_num'
        },
        {
          title: this.$t('l.mobile'),
          key: 'mobile'
        },
        {
          title: this.$t('l.username'),
          key: 'username'
        },
        {
          title: this.$t('l.operation'),
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ]
    },
    getLang() {
      return this.lang;
    },
    communityMap() {
      let map = {};
      this.search.community_id.values.forEach(comm => {
        comm.j_region = util.parseJSON(comm.j_region);
        map[comm.id] = comm;
      })
      return map;
    },
    chargerMap() {
      let map = {};
      this.search.j_alarm_charger.values.forEach(charger => {
        map[charger.mobile] = charger;
      })
      return map;
    },
    fzrMap() {
      let map = {};
      this.search.j_fzrs.values.forEach(fzr => {
        map[fzr.mobile] = fzr;
      })
      return map;
    },
    mtWorkersMap() {
      let map = {};
      this.search.j_mt_woker.values.forEach(mt => {
        map[mt.mobile] = mt;
      })
      return map;
    },
    deviceMap() {
      let map = {};
      this.table.data.forEach(device => {
        if (device.terminal_id) {
          map[device.terminal_id] = device;
        } else {
          if (device.vm_device_id) map[device.vm_device_id] = device;
        }
      })
      return map;
    },
    getRules() {
      return {
        'device.name': [{required: true, message: this.$t('l.remark33'), trigger: 'blur'}],
        totalFloor: [{validator: this.validateTotalFloor, trigger: 'blur', type: 'number'}],
      }
    },
    formRules() {
      return {
        username: [
          {required: true, message: this.$t('l.remark38'), trigger: 'blur'},
          // {validator: this.validateUsername, trigger: 'blur'}
        ],
        realname: [
          {required: true, message: this.$t('l.remark39'), trigger: 'blur'}
        ],
        password: [
          {required: true, message: this.$t('l.remark39_a'), trigger: 'blur'},
          {required: true, validator: validatePass, trigger: 'blur'}
        ],
        confirmPassword: [
          {required: true, message: this.$t('l.remark39_b'), trigger: 'blur'},
          {required: true, validator: validatePass, trigger: 'blur'},
          {validator: this.validatePasswrod, trigger: 'blur'}
        ],
        j_depart_ids: [
          {required: true, type: 'array', min: 1, message: this.$t('l.remark103'), trigger: 'on-select'}
        ],
        // mobile: [
        //     {required: true, message: this.$t('l.remark41'), trigger: 'blur'},
        //     {validator: this.validateMobile, trigger: 'blur'}
        // ],
        email: [
          {validator: this.validateEmail, trigger: 'blur'}
        ]
      }
    },

  },
  created() {
    this.getResources();
    this.loadRoleData();
    this.loadOptions();
    this.loadRegionData();
  },
  mounted() {
    this.offsetHeight = this.$refs.visibleDevicRow.offsetHeight;
  }
}
</script>

<style scoped lang="less">
.menu1-children {
  margin-left: 20px;
}

.menu2-children {
  margin-left: 40px;
}

.add-user:visited {
  color: #3399FF;
}

.unsubscribe {
  color: #cfcfcf;
}

</style>